/** @format */

import { shouldCacheBustScript } from './registry';
import type { CmsEmbedProvider } from './types';

function appendCacheBust(src: string): string {
  const separator = src.includes('?') ? '&' : '?';
  return `${src}${separator}_=${Date.now()}`;
}

function loadExternalScript(src: string, { cacheBust = false }: { cacheBust?: boolean } = {}): Promise<HTMLScriptElement> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = cacheBust ? appendCacheBust(src) : src;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
}

export async function loadCmsHtmlScripts(
  scriptSources: string[],
  activeProviders?: CmsEmbedProvider[]
): Promise<void> {
  for (const src of scriptSources) {
    await loadExternalScript(src, {
      cacheBust: shouldCacheBustScript(src, activeProviders)
    });
  }
}
